import React from 'react';

const Contact = () => {
    return (
        <div className='bg-primary  '>
             <h1 className='text-center mt-8 mb-8 lg:mt-32 lg:text-4xl text-sm font-bold flex justify-center items-center p-16 text-white'>READY TO DESIGN YOUR SPACE? CALL NOW!<span className='ml-20 bg-white text-primary p-4'> +8801634243558</span></h1>
        </div>
    );
};

export default Contact;